<div
 class="select-filter h50 fx-row fx-wrap fx-start-start fx-gap-1">
  <div class="fx-100 fx-50-xs"
      *ngFor="let agent of agentsList | async" >
      <button mat-button (click)=" bindUserAndMember(agent)">
          {{ agent.firstname }}  {{ agent.lastname }}
      </button> 
  </div>
</div>